import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const LockIcon = () => {
  return /*#__PURE__*/_jsxs("svg", {
    "aria-hidden": true,
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 21 20",
    fill: "none",
    children: [/*#__PURE__*/_jsx("circle", {
      cx: "10.5",
      cy: "10",
      r: "10",
      fill: "var(--ds-icon, #44546F)"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.16699 9.16667H5.91699V15.8333H15.0837V9.16667L13.8337 9.16667V7.5C13.8337 5.65905 12.3413 4.16667 10.5003 4.16667C8.65938 4.16667 7.16699 5.65905 7.16699 7.5L7.16699 9.16667ZM8.83366 9.16667V7.5C8.83366 6.57953 9.57985 5.83333 10.5003 5.83333C11.4208 5.83333 12.167 6.57953 12.167 7.5V9.16667L8.83366 9.16667Z",
      fill: "var(--ds-icon-inverse, #FFFFFF)"
    })]
  });
};